import BuzzerBridgeSipClient from './BuzzerBridgeSipClient';

export default new BuzzerBridgeSipClient();
